module.exports = __webpack_public_path__ + "static/img/beijing1.df5524c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/beijing1.jpg
// module id = NYUB
// module chunks = 1